import { create } from 'zustand';
import type { GameState } from './types';
import { createPlayerSlice } from './slices/player';
import { createMarketSlice } from './slices/market';
import { createTradeSlice } from './slices/trade';
import { createAdSlice } from './slices/ad';
import { createTutorialSlice } from './slices/tutorial';
import { createLaborSlice } from './slices/labor';
import { createUiSlice } from './slices/ui';

export const useGameStore = create<GameState>()((...a) => ({
  ...createPlayerSlice(...a),
  ...createMarketSlice(...a),
  ...createTradeSlice(...a),
  ...createAdSlice(...a),
  ...createTutorialSlice(...a),
  ...createLaborSlice(...a),
  ...createUiSlice(...a),
}));

export type { GameState } from './types';
